<template>
    <div class="page_content">
        <div class="row page-heading mx-0">
            <div class="col-8 input module_heading">
                <span class="module_icon fa fa-toolbox" style="color: #157099;"></span>
                <span class="module_type_name">Tool Management</span>
            </div>
            <div class="col-4 submit btn-container text-right">
                <button type="button" class="btn btn-primary" @click.prevent="save" aria-label="save">save</button>
                <button type="button" class="btn btn-primary" @click.prevent="cancel" aria-label="cancel">cancel</button>
            </div>
        </div>

        <div class="content-section-with-bg-brdr">
            <div class="row field-row">
                <div class="col-11 row">
                    <div class="col-2 form-label" id="title">Title <sup>*</sup></div>
                    <div class="col-4">
                        <b-form-input v-model.trim="title" :state="titleState"
                            aria-labelledby="title" placeholder="Title"
                            @blur="$v.title.$touch()"
                            aria-describedby="titleFeedback" v-focus style="height: 40px !important;">
                        </b-form-input>
                        <b-form-invalid-feedback id="titleFeedback">
                            Title must not be empty
                        </b-form-invalid-feedback>
                    </div>
                    <div class="col-2 form-label" id="description">Description</div>
                    <div class="col-4">
                        <b-form-input v-model.trim="description" placeholder="Description" style="height: 40px !important;"></b-form-input>
                    </div>
                </div>
            </div>

            <div class="row field-row">
                <div class="col-11 row">
                    <div class="col-2 form-label" id="consumerKey">Consumer Key <sup>*</sup></div>
                    <div class="col-4">
                        <b-form-input v-model.trim="consumerKey" :state="consumerKeyState"
                            aria-labelledby="consumerKey" placeholder="Consumer Key"
                            @blur="$v.consumerKey.$touch()"
                            aria-describedby="consumerKeyFeedback" style="height: 40px !important;">
                        </b-form-input>
                        <b-form-invalid-feedback id="consumerKeyFeedback">
                            Consumer Key must not be empty
                        </b-form-invalid-feedback>
                    </div>
                    <div class="col-2 form-label" id="sharedSecret">Shared Secret <sup>*</sup></div>
                    <div class="col-4">
                        <b-form-input v-model.trim="sharedSecret" :state="sharedSecretState"
                            aria-labelledby="sharedSecret" placeholder="Shared Secret"
                            @blur="$v.sharedSecret.$touch()"
                            aria-describedby="sharedSecretFeedback" style="height: 40px !important;">
                        </b-form-input>
                        <b-form-invalid-feedback id="sharedSecretFeedback">
                            Shared Secret must not be empty
                        </b-form-invalid-feedback>
                    </div>
                </div>
            </div>

            <div class="row field-row">
                <div class="col-11 row">
                    <div class="col-2 form-label" id="type">Configuration Type <sup>*</sup></div>
                    <div class="col-4">
                        <select class="form-control" v-model="type" style="width: 98%; height: 30px !important;">
                            <option v-for="option in typeOptions" v-bind:value="option" >{{ option }}</option>
                        </select>
                    </div>
                    <div class="col-2 form-label" id="launchURL">Launch Url <sup>*</sup></div>
                    <div class="col-4">
                        <b-form-input v-model.trim="launchURL" :state="launchURLState"
                            aria-labelledby="launchURL" placeholder="http://"
                            @blur="$v.launchURL.$touch()"
                            aria-describedby="launchURLFeedback" style="height: 40px !important;">
                        </b-form-input>
                        <b-form-invalid-feedback id="launchURLFeedback">
                            Launch URL must be valid
                        </b-form-invalid-feedback>
                    </div>
                </div>
            </div>

            <div class="row field-row">
                <div class="col-11 row">
                    <div class="col-2 form-label" id="toolIconUrl">Icon Url</div>
                    <div class="col-4">
                        <b-form-input v-model.trim="toolIconUrl" :state="toolIconUrlState"
                            aria-labelledby="toolIconUrl" placeholder="http://"
                            @blur="$v.toolIconUrl.$touch()"
                            aria-describedby="toolIconUrlFeedback" style="height: 40px !important;">
                        </b-form-input>
                        <b-form-invalid-feedback id="toolIconUrlFeedback">
                            Icon URL must be valid
                        </b-form-invalid-feedback>
                    </div>
                    <div class="col-2 form-label" id="initURL">Init Url <sup>*</sup></div>
                    <div class="col-4">
                        <b-form-input v-model.trim="initURL" :state="initURLState"
                            aria-labelledby="initURL" placeholder="http://"
                            @blur="$v.initURL.$touch()"
                            aria-describedby="initURLFeedback" style="height: 40px !important;">
                        </b-form-input>
                        <b-form-invalid-feedback id="initURLFeedback">
                            Init URL must be valid
                        </b-form-invalid-feedback>
                    </div>

                </div>
            </div>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>

    </div>

</template>

<script>
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import {required, url} from 'vuelidate/lib/validators'
  Vue.use(Vuelidate)
  Vue.directive('focus', {
    inserted (el) {
      el.focus()
    }
  })

  export default {
    name: 'toolCreate',
    props: ['uuid'],
    data () {
      return {
        title: '',
        description: '',
        consumerKey: '',
        sharedSecret: '',
        type: 'ByURL',
        launchURL: '',
        initURL:'',
        toolIconUrl: '',
        typeOptions: ['ByURL', 'Manual']
      }
    },

    validations: {
      title: {
        required
      },
      consumerKey: {
        required
      },
      sharedSecret: {
        required
      },
      launchURL: {
        required,
        url
      },
      initURL: {
        required,
        url
      },
      toolIconUrl: {
        url
      }
    },

    computed: {
      titleState () {
        return !this.$v.title.$error
      },

      consumerKeyState () {
        return !this.$v.consumerKey.$error
      },

      sharedSecretState () {
        return !this.$v.sharedSecret.$error
      },

      launchURLState () {
        return !this.$v.launchURL.$error
      },
      initURLState () {
        return !this.$v.initURL.$error
      },
      toolIconUrlState () {
        return !this.$v.toolIconUrl.$error
      }
    },

    mounted () {
      if (this.uuid) {
        this.loadTool()
      }
    },

    methods: {
      ...mapActions([
        'createTool',
        'loadToolDetail'
      ]),

      cancel () {
        this.$router.go(-1)
      },

      save () {
        this.$v.$touch()
        if (this.titleState && this.consumerKeyState && this.sharedSecretState && this.launchURLState && this.initURLState && this.toolIconUrlState) {
          this.$refs.loadingModal.show()
          let tool = {
            toolName: this.title,
            description: this.description,
            consumerKey: this.consumerKey,
            sharedSecret: this.sharedSecret,
            type: this.type,
            launchURL: this.launchURL,
            initURL: this.initURL,
            configurationURL: this.launchURL,
            toolIconUrl: this.toolIconUrl
          }
          let status = 'success'
          let text = 'Tool "' + this.title + '" created successfully.'
          if (this.uuid) {
            tool.uuid = this.uuid
            text = 'Tool "' + this.title + '" updated successfully.'
          }
          this.createTool(tool).then(res => {
            if (res) {
              if (res.status === 409) {
                text = 'Tool "' + this.title + '" already exists.'
                status = 'warn'
              }
              this.$notify({
                group: 'notify',
                type: status,
                title: '',
                text: text
              })
            }
            setTimeout(() => {
              this.$refs.loadingModal.hide()
              return this.$router.push({name: 'toolList'})
            }, 500)
          })
        }
      },

      loadTool () {
        this.loadToolDetail(this.uuid).then(res => {
          if (res) {
            this.title = res.toolName
            this.description = res.description
            this.consumerKey = res.consumerKey
            this.sharedSecret = res.sharedSecret
            this.type = res.type
            this.launchURL = res.launchURL
            this.initURL = res.initURL
            this.toolIconUrl = res.toolIconUrl
          }
        })
      }
    }
  }
</script>

<style scoped>
  sup {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/app/tool/components/ToolCreate.vue